module.exports = __webpack_public_path__ + "static/media/holly-michaels-win.f4a6dcbb.jpg";